import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { resetStore } from "./resetStore";
import { apiRequest } from "../../Utils/apiClient";
import { clearJwtToken } from "../../Utils/authStorage";
import axios from "axios";
import { getServerUrl } from "../../Utils/serverSelector";

const getError = (error, fallback) =>
  error?.response?.data?.message ||
  error?.response?.data?.error ||
  error?.message ||
  fallback;

const handleAuthError = async (error) => {
  const status = error?.response?.status;
  if (status === 401 || status === 403) {
    try {
      await clearJwtToken();
    } catch { }
  }
};

const getUid = (getState, providedUid) => {
  const state = getState();
  const uid =
    providedUid ||
    state?.master?.master?.uid ||
    state?.master?.uid ||
    state?.auth?.uid ||
    null;

  if (!uid) throw new Error("UID required");
  return uid;
};

export const submitTakbullSignup = createAsyncThunk(
  "takbullSignup/submit",
  async ({ body }, { rejectWithValue }) => {
    try {

      const response = await axios.post(
        `${getServerUrl()}/payments/takbull/signup`,
        body,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        error?.message ||
        "Takbull signup failed"
      );
    }
  }
);

const initialState = {
  status: "idle",
  error: null,
  lastLead: null,
  account: null,
  mode: null,
  payloadPreview: null,
  redirect: null,
};

const takbullSignupSlice = createSlice({
  name: "takbullSignup",
  initialState,
  reducers: {
    clearTakbullSignupError: (state) => {
      state.error = null;
    },
    clearTakbullSignupResult: (state) => {
      state.status = "idle";
      state.error = null;
      state.lastLead = null;
      state.account = null;
      state.mode = null;
      state.payloadPreview = null;
      state.redirect = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitTakbullSignup.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(submitTakbullSignup.fulfilled, (state, { payload }) => {
        state.status = "succeeded";
        state.lastLead = payload?.lead || null;
        state.account = payload?.account || null;
        state.mode = payload?.mode || null;
        state.payloadPreview = payload?.takbullPayloadPreview || null;
        state.redirect = payload?.redirect || null;
      })
      .addCase(submitTakbullSignup.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || action.error?.message || "Signup failed";
      })
      .addCase(resetStore, () => initialState);
  },
});

export const {
  clearTakbullSignupError,
  clearTakbullSignupResult,
} = takbullSignupSlice.actions;

export const selectTakbullSignup = (state) => state.takbullSignup || initialState;
export const selectTakbullSignupStatus = (state) => selectTakbullSignup(state).status;
export const selectTakbullSignupError = (state) => selectTakbullSignup(state).error;
export const selectTakbullSignupMode = (state) => selectTakbullSignup(state).mode;
export const selectTakbullPayloadPreview = (state) =>
  selectTakbullSignup(state).payloadPreview;

export default takbullSignupSlice.reducer;
